import React from 'react';
import { useSelector } from 'react-redux';
import CommonColorPicker from './CommonColorPicker.jsx';

function DashboardColorPicker(props) {
  const globalPalette = useSelector(state => state.dashboard.theme?.palette?.fills);
  return (
    <CommonColorPicker palette={globalPalette} paletteTitle={I18n.t('global_palette')} {...props} />
  )
}

export default DashboardColorPicker;